const STORAGE_KEY = 'pixlide.last-account';

/**
 * Mémorisation de la dernière adresse connectée, pour l'écran « rebonjour » de la maquette.
 *
 * Seule l'ADRESSE est conservée, jamais le mot de passe ni un jeton : sur un poste partagé,
 * la conséquence maximale d'une fuite est de révéler qui s'est connecté la dernière fois —
 * ce que la personne suivante lit de toute façon sur l'écran. Le bouton « Changer de
 * compte » l'efface immédiatement.
 *
 * Chaque appel est protégé : `localStorage` lève une exception quand le stockage est
 * désactivé (navigation privée sur certains navigateurs, politique d'entreprise). Un
 * confort d'affichage ne doit jamais empêcher quelqu'un de se connecter.
 */
export function readLastAccount(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function rememberLastAccount(email: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, email);
  } catch {
    // Sans stockage, l'écran repart simplement d'un champ vide.
  }
}

export function forgetLastAccount(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Idem : rien à faire, l'état local du composant a déjà été remis à zéro.
  }
}
